var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { LoadingOutlined } from '@ant-design/icons';
import { useMixpanel, useService } from '@tenderd/track-web-utils';
import { Button, Card, Col, Divider, Popover, Row, Spin, Statistic, Table, message, } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useHistory } from 'react-router-dom';
import { GroupsMachinesPageEvents } from '../../../../constants/AnalyticsEvents';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { i18n } from '../../../../translations';
import { GroupAnalyticsNewTKeys } from '../../../../translations/keys';
var OvertimeStatsCard = function (props) {
    var groupService = useGroupService();
    var history = useHistory();
    var mixpanel = useMixpanel();
    var service = useService();
    var _a = __read(useState(true), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState(), 2), analyticsData = _b[0], setAnalyticsData = _b[1];
    var _c = __read(useState([]), 2), overTimeTableData = _c[0], setOverTimeTableData = _c[1];
    var _d = __read(useState({}), 2), equipmentInProjectMap = _d[0], setEquipmentInProjectMap = _d[1];
    useEffect(function () {
        setLoading(props.loading);
    }, [props.loading]);
    useEffect(function () {
        setAnalyticsData(props.data);
        setLoading(false);
    }, [props.data]);
    useEffect(function () {
        setOverTimeTableData(props.overtimeTableData);
        setLoading(false);
    }, [props.overtimeTableData]);
    var generateTooltip = function (title, items, equipmentMap) {
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { style: { paddingLeft: 0 } }, items === null || items === void 0 ? void 0 : items.map(function (item, index) {
                var name = item.name, value = item.value, color = item.color;
                return (React.createElement(React.Fragment, { key: item.year },
                    React.createElement("li", { className: "g2-tooltip-list-item", "data-index": index, style: {
                            marginBottom: 4,
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        React.createElement("span", { className: "g2-tooltip-marker", style: { backgroundColor: color } }),
                        React.createElement("span", { style: {
                                display: 'inline-flex',
                                flex: 1,
                                justifyContent: 'space-between',
                            } },
                            React.createElement("span", { style: { marginRight: '16' } }, name))),
                    React.createElement("ul", null,
                        !equipmentMap && (React.createElement("div", { style: {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            } },
                            React.createElement(Spin, { style: { margin: '0px' }, indicator: React.createElement(LoadingOutlined, { style: { fontSize: 13 }, spin: true }) }),
                            React.createElement("p", { style: {
                                    marginLeft: '5px',
                                    marginTop: '3px',
                                } },
                                "Loading projects...",
                                ' '))),
                        equipmentMap &&
                            equipmentMap[item.data.id] &&
                            equipmentMap[item.data.id].map(function (e) {
                                return (React.createElement("li", { style: { marginBottom: 5 }, key: e.name }, e.name));
                            }),
                        equipmentMap &&
                            equipmentMap[item.data.id] &&
                            equipmentMap[item.data.id].length ===
                                0 && React.createElement("p", null, "No projects"))));
            }))));
    };
    var goToMachine = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var equipment, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, service.server.getGroupEquipmentsDetails(groupService.group.id, id)];
                case 1:
                    equipment = _a.sent();
                    history.push("./analytics/".concat(equipment.id));
                    mixpanel.track(GroupsMachinesPageEvents.ClickedViewMachine, {
                        equipmentId: equipment.doc.equipment_ref.id,
                        equipmentName: equipment.doc.equipment_ref.label,
                        extension: 'track',
                    });
                    ReactGA.event({
                        category: "".concat(GroupsMachinesPageEvents.ClickedViewMachine),
                        action: 'Track WebApp',
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    message.error(error_1.message);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Col, { span: 24 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { headStyle: { fontSize: '16px' }, title: React.createElement(React.Fragment, null, i18n.t(GroupAnalyticsNewTKeys.overtimeStatistics)) },
                React.createElement(Row, { gutter: 12 },
                    React.createElement(Col, { span: 5 },
                        React.createElement("div", { className: "big-metric" },
                            React.createElement(Statistic, { style: {
                                    flexDirection: 'column-reverse',
                                    display: 'flex',
                                }, title: React.createElement(React.Fragment, null,
                                    React.createElement(Divider, null),
                                    i18n.t(GroupAnalyticsNewTKeys.timesMachinesExceeded)), value: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.times_equipment_usage_exceeded, valueStyle: { fontSize: '3vw' } }))),
                    React.createElement(Col, { span: 5 },
                        React.createElement("div", { className: "big-metric" },
                            React.createElement(Statistic, { style: {
                                    flexDirection: 'column-reverse',
                                    display: 'flex',
                                }, title: React.createElement(React.Fragment, null,
                                    React.createElement(Divider, null),
                                    i18n.t(GroupAnalyticsNewTKeys.totalOvertime)), value: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.total_overtime_hours.toFixed(1), valueStyle: { fontSize: '3vw' } }))),
                    React.createElement(Col, { span: 14, offset: 0 },
                        React.createElement(Table, { dataSource: overTimeTableData.sort(function (a, b) {
                                return b.total_overtime_hours -
                                    a.total_overtime_hours;
                            }), rowKey: "key", bordered: true, size: "small", pagination: false },
                            React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.machine), dataIndex: ['label'], render: function (text, record, i) {
                                    return (React.createElement(React.Fragment, null,
                                        React.createElement(Popover, { placement: "topLeft", content: generateTooltip('', [
                                                {
                                                    name: text,
                                                    data: {
                                                        id: overTimeTableData[i].id,
                                                    },
                                                },
                                            ], equipmentInProjectMap), title: null, trigger: "hover" },
                                            React.createElement(Button, { type: "link", onClick: function () {
                                                    goToMachine(record.id);
                                                }, style: {
                                                    color: 'inherit',
                                                } },
                                                React.createElement("span", { style: {
                                                        textTransform: 'capitalize',
                                                    } }, text)))));
                                } }),
                            React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.day), dataIndex: ['days'], sorter: true }),
                            React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.telematicsHours), dataIndex: ['total_overtime_hours'], sorter: {
                                    compare: function (a, b) {
                                        return a.total_overtime_hours -
                                            b.total_overtime_hours;
                                    },
                                }, render: function (text, record) {
                                    return (React.createElement("span", null, record.total_overtime_hours.toFixed(1)));
                                } }))))))));
};
export default OvertimeStatsCard;
